import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';
import EldOrganizationSettings from 'src/pages/app/eld/eld-organization-settings';
import EldDormancySettings from 'src/pages/app/eld/eld-dormancy-settings';
import EldDrivers from 'src/pages/app/eld/eld-drivers/list';
import EldDriversInactive from 'src/pages/app/eld/eld-drivers/inactive';
import EldDvirs from 'src/pages/app/eld/eld-dvirs/list';
import EldVehicles from 'src/pages/app/eld/eld-vehicles/list';
import EldDevices from 'src/pages/app/eld/eld-devices/list';
import EldUsers from 'src/pages/app/eld/eld-users/list';
import EldInspections from 'src/pages/app/eld/eld-inspections/list';

import EldDriverLogsList from 'src/pages/app/eld/eld-driver-logs/list';
import EldDriverLogsDriver from 'src/pages/app/eld/eld-driver-logs/driver';
import EldDriverLogsSingle from 'src/pages/app/eld/eld-driver-logs/single';
import EldAllLogsList from 'src/pages/app/eld/eld-all-logs/list';
import EldIftaReport from 'src/pages/app/eld/eld-ifta/report';
import EldLandmark from 'src/pages/app/eld/eld-landmarks/list';
import EldTrailersPerTruck from 'src/pages/app/eld/eld-trailers-per-truck/list';
import EldAssetsPerLandmark from 'src/pages/app/eld/eld-assets-per-landmark/list';
import EldAssetsPerLandmarkHistory from 'src/pages/app/eld/eld-assets-per-landmark/history';
import EldAssetsPerLandmarkSingle from 'src/pages/app/eld/eld-assets-per-landmark/single';
import EldAssetNotifications from 'src/pages/app/eld/eld-asset-notifications/list';
import SharePage from 'src/pages/share';
import LandmarkSharePage from 'src/pages/landmark-share';


import EldUnidentifiedEventsList from 'src/pages/app/eld/eld-unidentified-events/list';
import DevicesMapPage from 'src/pages/app/devices/map';
import DevicesAddPage from 'src/pages/app/devices/add';

import CamerasListPage from 'src/pages/app/cameras/list';
import CamerasNotificationsListPage from 'src/pages/app/cameras/notifications/list';

import TrailersList from 'src/pages/app/rentals/trailers/list';
import InactiveTrailers from 'src/pages/app/rentals/trailers/inactive';
import CustomersList from 'src/pages/app/rentals/customers/list';
import InactiveCustomers from 'src/pages/app/rentals/customers/inactive';
import RentalOrganizationSettings from 'src/pages/app/rentals/rental-organization-settings';
import IndexPage from 'src/pages/app';
import DormantAssetsReport from 'src/pages/app/reports/dormant-assets-report';
import HarshBreakingReport from 'src/pages/app/reports/harsh-breaking-report';
import ScheduledReports from 'src/pages/app/scheduled-reports/list';

// ----------------------------------------------------------------------

// const OrganizationSettingsPage = lazy(() => import('src/pages/app/organization/settings'));

// const OrganizationUsersListPage = lazy(() => import('src/pages/app/organization-users/list'));
// const OrganizationUsersSinglePage = lazy(() => import('src/pages/app/organization-users/single'));
// const ProfileEditPage = lazy(() => import('src/pages/app/profile/edit'));

// const DevicesMapPage = lazy(() => import('src/pages/app/devices/map'));

// const DriversListPage = lazy(() => import('src/pages/app/drivers/list'));
// const DriversInactivePage = lazy(() => import('src/pages/app/drivers/inactive'));
// const TrucksListPage = lazy(() => import('src/pages/app/trucks/list'));
// const TrucksInactivePage = lazy(() => import('src/pages/app/trucks/inactive'));

// const DebtsListPage = lazy(() => import('src/pages/app/debts/list'));
// const MaintenanceItemsListPage = lazy(() => import('src/pages/app/maintenance-items/list'));

// const AccidentsListPage = lazy(() => import('src/pages/app/accidents/list'));
// const AccidentsClosedPage = lazy(() => import('src/pages/app/accidents/closed'));

// const EquipmentListPage = lazy(() => import('src/pages/app/equipment/list'));
// const EquipmentInactivePage = lazy(() => import('src/pages/app/equipment/inactive'));
// const BusinessPartnersListPage = lazy(() => import('src/pages/app/business-partners/list'));
// const BusinessPartnersInactivePage = lazy(() => import('src/pages/app/business-partners/inactive'));
// const FuelChargesListPage = lazy(() => import('src/pages/app/fuel-charges/list'));
// const CreditsListPage = lazy(() => import('src/pages/app/credits/list'));
// const TollChargesListPage = lazy(() => import('src/pages/app/toll-charges/list'));
// const DeductionsListPage = lazy(() => import('src/pages/app/deductions/list'));

// const RemindersListPage = lazy(() => import('src/pages/app/reminders/list'));

// const MaintenanceRemindersListPage = lazy(() => import('src/pages/app/maintenance-reminders/list'));

// const LoadsListPage = lazy(() => import('src/pages/app/loads/list'));
// const HistoricLoadsListPage = lazy(() => import('src/pages/app/loads/historic'));
// const LoadSinglePage = lazy(() => import('src/pages/app/loads/single'));

// const MaintenanceListPage = lazy(() => import('src/pages/app/maintenances/list'));
// const MaintenanceSinglePage = lazy(() => import('src/pages/app/maintenances/single'));

// const StatementsListPage = lazy(() => import('src/pages/app/statements/list'));
// const HistoricStatementsListPage = lazy(() => import('src/pages/app/statements/historic'));
// const StatementSinglePage = lazy(() => import('src/pages/app/statements/single'));

// const RevenueReportsListPage = lazy(() => import('src/pages/app/revenue-reports/list'));
// const HistoricRevenueReportsListPage = lazy(() => import('src/pages/app/revenue-reports/historic'));
// const RevenueReportsSinglePage = lazy(() => import('src/pages/app/revenue-reports/single'));

// const IftaListPage = lazy(() => import('src/pages/app/ifta/list'));
// const IftaSinglePage = lazy(() => import('src/pages/app/ifta/single'));

// ----------------------------------------------------------------------

export const appRoutes = [
  {
    path: 'share/:shareLinkUuid',
    element: <SharePage />
  },
  {
    path: 'landmark-share/:shareLinkUuid',
    element: <LandmarkSharePage />
  },
  {
    path: 'app',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <IndexPage />, index: true },
      // {
      //   path: 'organization',
      //   children: [
      //     { path: 'settings', element: <OrganizationSettingsPage /> },
      //   ],
      // },
      {
        path: 'rentals',
        children: [
          {path: 'trailers', children: [
            { path: 'list', element: <TrailersList /> },
            { path: 'inactive', element: <InactiveTrailers /> }
          ]},
          {path: 'customers', children: [
            { path: 'list', element: <CustomersList /> },
            { path: 'inactive', element: <InactiveCustomers /> },
          ]},
          { path: 'rental-organization-settings', element: <RentalOrganizationSettings /> },
        ],
      },
      {
        path: 'reports',
        children: [
          { path: 'dormant-assets', element: <DormantAssetsReport /> },
          { path: 'harsh-breaking', element: <HarshBreakingReport /> },
        ],
      },
      {
        path: 'scheduled-reports',
        children: [
          {
            path: "list",
            element: <ScheduledReports />
          }
        ]

      },
      {
        path: 'eld',
        children: [
          { path: 'eld-organization-settings', element: <EldOrganizationSettings /> },
          { path: 'eld-dormancy-settings', element: <EldDormancySettings /> },
          {
            path: 'eld-drivers', children: [
              { path: 'list', element: <EldDrivers /> },
              { path: 'inactive', element: <EldDriversInactive /> }
            ]
          },
          {
            path: 'eld-assets-per-landmark', children: [
              { path: 'list', element: <EldAssetsPerLandmark /> },
              { path: 'single/:eldLandmarkId', element: <EldAssetsPerLandmarkSingle /> },
              { path: 'history/:eldLandmarkId', element: <EldAssetsPerLandmarkHistory /> },
            ]
          },
          {
            path: 'eld-landmarks', children: [
              { path: 'list', element: <EldLandmark /> },
            ]
          },
          {
            path: 'eld-trailers-per-truck', children: [
              { path: 'list', element: <EldTrailersPerTruck /> },
            ]
          },
          {
            path: 'eld-asset-notifications', children: [
              { path: 'list', element: <EldAssetNotifications /> },
            ]
          },
          {
            path: 'eld-dvirs', children: [
              { path: 'list', element: <EldDvirs /> }
            ]
          },
          {
            path: 'eld-vehicles', children: [
              { path: 'list', element: <EldVehicles /> }
            ]
          },
          {
            path: 'eld-devices', children: [
              { path: 'list', element: <EldDevices /> }
            ]
          },
          {
            path: 'eld-users', children: [
              { path: 'list', element: <EldUsers /> }
            ]
          },
          {
            path: 'eld-driver-logs', children: [
              { path: 'list', element: <EldDriverLogsList /> },
              {
                path: 'driver', children: [
                  { path: ':eldDriverId', element: <EldDriverLogsDriver /> }
                ]
              },
              { path: 'single/:eldDriverId/:logDate', element: <EldDriverLogsSingle /> }
            ]
          },
          { path: 'eld-inspections', children: [{ path: 'list', element: <EldInspections /> }] },
          { path: 'eld-ifta', children: [{ path: 'report', element: <EldIftaReport /> }] },
          { path: 'eld-all-logs', children: [{ path: 'list', element: <EldAllLogsList /> }] },
          { path: 'eld-unidentified-events', children: [{ path: 'list', element: <EldUnidentifiedEventsList /> }] },
        ]
      },
      // {
      //   path: 'drivers',
      //   children: [
      //     { path: 'list', element: <DriversListPage /> },
      //     { path: 'inactive', element: <DriversInactivePage /> }
      //   ],
      // },
      {
        path: 'cameras',
        children: [
          { path: 'list', element: <CamerasListPage /> },
          {
            path: 'notifications',
            children: [
              { path: 'list', element: <CamerasNotificationsListPage /> },

            ],
          },
        ],
      },
      {
        path: 'devices',
        children: [
          { path: 'map', element: <DevicesMapPage /> },
          { path: 'add', element: <DevicesAddPage /> },
        ],
      },
      // {
      //   path: 'trucks',
      //   children: [
      //     { path: 'list', element: <TrucksListPage /> },
      //     { path: 'inactive', element: <TrucksInactivePage /> }
      //   ],
      // },
      // {
      //   path: 'debts',
      //   children: [
      //     { path: 'list', element: <DebtsListPage /> },
      //   ],
      // },
      // {
      //   path: 'maintenance-items',
      //   children: [
      //     { path: 'list', element: <MaintenanceItemsListPage /> },
      //   ],
      // },
      // {
      //   path: 'maintenances',
      //   children: [
      //     { path: 'list', element: <MaintenanceListPage /> },
      //     { path: ':id', element: <MaintenanceSinglePage /> }
      //   ],
      // },
      // {
      //   path: 'accidents',
      //   children: [
      //     { path: 'list', element: <AccidentsListPage /> },
      //     { path: 'closed', element: <AccidentsClosedPage /> }
      //   ],
      // },
      // {
      //   path: 'equipment',
      //   children: [
      //     { path: 'list', element: <EquipmentListPage /> },
      //     { path: 'inactive', element: <EquipmentInactivePage /> }
      //   ],
      // },
      // {
      //   path: 'business-partners',
      //   children: [
      //     { path: 'list', element: <BusinessPartnersListPage /> },
      //     { path: 'inactive', element: <BusinessPartnersInactivePage /> }
      //   ],
      // },
      // {
      //   path: 'deductions',
      //   children: [
      //     { path: 'list', element: <DeductionsListPage /> }
      //   ],
      // },
      // {
      //   path: 'fuel-charges',
      //   children: [
      //     { path: 'list', element: <FuelChargesListPage /> }
      //   ],
      // },
      // {
      //   path: 'credits',
      //   children: [
      //     { path: 'list', element: <CreditsListPage /> }
      //   ],
      // },
      // {
      //   path: 'toll-charges',
      //   children: [
      //     { path: 'list', element: <TollChargesListPage /> }
      //   ],
      // },
      // {
      //   path: 'reminders',
      //   children: [
      //     { path: 'list', element: <RemindersListPage /> }
      //   ],
      // },
      // {
      //   path: 'maintenance-reminders',
      //   children: [
      //     { path: 'list', element: <MaintenanceRemindersListPage /> }
      //   ],
      // },
      // {
      //   path: 'statements',
      //   children: [
      //     { path: 'list', element: <StatementsListPage /> },
      //     { path: 'historic', element: <HistoricStatementsListPage /> },
      //     { path: ':id', element: <StatementSinglePage /> }
      //   ]
      // },
      // {
      //   path: 'revenue-reports',
      //   children: [
      //     { path: 'list', element: <RevenueReportsListPage /> },
      //     { path: 'historic', element: <HistoricRevenueReportsListPage /> },
      //     { path: ':id', element: <RevenueReportsSinglePage /> }
      //   ]
      // },
      // {
      //   path: 'loads',
      //   children: [
      //     { path: 'list', element: <LoadsListPage /> },
      //     { path: 'historic', element: <HistoricLoadsListPage /> },
      //     { path: ':id', element: <LoadSinglePage /> }
      //   ]
      // },
      // {
      //   path: 'organization-users',
      //   children: [
      //     { path: 'list', element: <OrganizationUsersListPage /> },
      //     { path: ':id', element: <OrganizationUsersSinglePage /> }
      //   ]
      // },
      // {
      //   path: 'profile',
      //   children: [
      //     { path: 'edit', element: <ProfileEditPage /> },
      //   ]
      // },
      // {
      //   path: 'ifta',
      //   children: [
      //     { path: 'list', element: <IftaListPage /> },
      //     { path: ':id', element: <IftaSinglePage /> }
      //   ]
      // }
    ],
  },
];
